<!-- ヘッダー部分 -->
<div class="title-area">
  <h2 class="title">イベント検索</h2>
  <!-- 件数表示 -->
  @if (masterLoaded) {
    <div class="results-count">
      <span class="count-text">
        <span class="count-highlight">{{ totalCount }}</span>件中　{{ displayFrom }}-{{ displayTo }}件表示
      </span>
    </div>
  }
</div>

<!-- 検索・絞込 -->
<div class="tab-filter-area-container">
  @if (masterLoaded) {
    <app-event-search-filter
      [masterData]="MasterData"
      (search)="onFilterSearch($event)">
    </app-event-search-filter>
  }
</div>

<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <!-- 承認タブ -->
  <table class="event-table approval-table">
    <thead>
      <tr>
        <th class="col-document-type">帳票</th>
        <th class="col-drafter">起票者</th>
        <th class="col-event">イベント</th>
        <th class="col-unit">開催単位</th>
        <th class="col-participants">参加人数</th>
        <th class="col-participant-eval">参加者評価</th>
        <th class="col-scope">コピー回数</th>
        <th class="col-dates">開催日</th>
      </tr>
    </thead>
    <tbody>
      @for (event of approvalEvents; track event.id) {
        <tr>
          <!-- 帳票 -->
          <td class="col-document-type">
            <div class="document-type-content">
              <span>{{ getDocumentTypeLabel(event.documentType, event.status) }}</span>
            </div>
          </td>

          <!-- 起票者 -->
          <td class="col-drafter">
            <div class="drafter-content">
              @if (event.otherCompany) {
                <div class="drafter-line">他組織</div>
              } @else if (event.drafter.branch) {
                <div class="drafter-line">{{ event.drafter.branch }}</div>
              }
              @if (!event.otherCompany) {
                @if (getDepartmentFromOrganizations(event)) {
                  <div class="drafter-line">
                    {{ event.drafter.organizations[0] }}
                  </div>
                }
              }
              @if (event.otherCompany) {
                <div class="drafter-line drafter-position">{{ getIndustryLargeLabel(event.industryLarge) }}</div>
              } @else if (event.drafter.position) {
                <div class="drafter-line drafter-position">{{ event.drafter.position }}</div>
              }
              @if (event.otherCompany) {
                <div class="drafter-line drafter-name">{{ getEmployeeSizeLabel(event.employeeSize) }}</div>
              } @else if (event.drafter.name) {
                <div class="drafter-line drafter-name">{{ event.drafter.name }}</div>
              }
            </div>
          </td>

          <!-- イベント -->
          <td class="col-event">
            <div class="event-content">
              @if (event.otherCompany) {
                <a class="event-title" (click)="onEventEXClick(event)">{{ event.title }}</a>
              } @else{
                <a class="event-title" (click)="onEventClick(event)">{{ event.title }}</a>
              }
              <div class="event-category">{{ event.category }}</div>
              <div class="event-description">{{ getTruncatedDescription(event.description) }}</div>
            </div>
          </td>

          <!-- 開催単位 -->
          <td class="col-unit">
            {{ event.holdingUnit }}
          </td>

          <!-- 参加人数 -->
          <td class="col-participants">
            <div class="participants-content">
              @if (event.participantCount !== null) {
                <div class="number-with-unit">
                  <span class="participant-count">{{ event.participantCount }}</span>
                  <span class="unit">人</span>
                </div>
                @if (event.coverageRate !== null) {
                  <div class="coverage-rate">
                    <span class="coverage-label">カバー率</span>
                    <span class="coverage-value">{{ event.coverageRate }} %</span>
                  </div>
                }
              } @else {
                <span>-</span>
              }
            </div>
          </td>

          <!-- 参加者評価 -->
          <td class="col-participants">
            <div class="participants-content">
              @if (event.participantEvalScore !== null) {
                <div class="number-with-unit">
                  <span class="participant-count">{{ getMasterName('report_eval_score', event.participantEvalScore) }}</span>
                </div>
                @if (getCollectionRate(event) !== null) {
                  <div class="coverage-rate">
                    <span class="coverage-label">収集率</span>
                    <span class="coverage-value">{{ getCollectionRate(event) }}</span>
                  </div>
                }
              } @else {
                <span>-</span>
              }
            </div>
          </td>

          <!-- コピー回数 -->
          <td class="col-scope">
          </td>

          <!-- 開催日など -->
          <td class="col-dates">
            <div class="dates-content">

              @for (date of getDisplayDates(event); track $index) {
                <div class="event-date">{{ date }}</div>
              }

              @if (hasMoreDates(event)) {
                <div class="more-dates">など</div>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <!-- ページング -->
  <div class="custom-pagination">
    <div class="pagination-container">

      @if (approvalEvents.length > 0) {

        @if (isFirstPage()) {
          <div class="paging-step paging-step-disable">
            <img src="assets/common/ChevronLeft_gray.svg" alt="前へ">
          </div>
        } @else {
          <button class="paging-step" (click)="previous()">
            <img src="assets/common/ChevronLeft.svg" alt="前へ">
          </button>
        }

        @for (page of pages; track page) {
          <div>
            @if (page !== this.page) {
              <div
                class="paging-link-container"
                (click)="goPage(page)">
                <span class="paging-text">{{ page }}</span>
              </div>
            } @else {
              <div class="current-page">
                <span class="paging-text">{{ page }}</span>
              </div>
            }
          </div>
        }

        @if (isLastPage()) {
          <div class="paging-step paging-step-disable">
            <img src="assets/common/ChevronRight_gray.svg" alt="次へ">
          </div>
        } @else {
          <button class="paging-step" (click)="next()">
            <img src="assets/common/ChevronRight.svg" alt="次へ">
          </button>
        }

      }

    </div>
  </div>

    <!-- イベントがない場合 -->
    @if (approvalEvents.length === 0) {
      <div class="no-events">
        イベントがありません。
      </div>
    }
}
